import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block">
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-800">
        <img
          src={movie.poster}
          alt={`${movie.title}影视封面`}
          title={`${movie.title} - ${movie.genre}剧情解析`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent"></div>
        <span className="absolute left-2 top-2 rounded bg-background-950/85 px-2 py-1 font-label text-[10px] uppercase tracking-[0.14em] text-accent-400">
          {movie.genre}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-background-950/85 px-2 py-1 text-[11px] text-foreground-900">
          <i className="ri-star-fill text-[10px] text-accent-400" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between px-3 pb-3">
          <span className="font-label text-xs uppercase tracking-[0.16em] text-foreground-600">
            {movie.year}
          </span>
          <span className="flex h-7 w-7 items-center justify-center rounded-full border border-foreground-700/40 text-foreground-800 transition-colors group-hover:border-accent-500 group-hover:bg-accent-500 group-hover:text-background-950">
            <i className="ri-arrow-right-up-line text-xs" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <h3 className="mt-3 text-base font-medium text-foreground-950 transition-colors group-hover:text-accent-400">
        {movie.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500">
        {movie.director} 导演 · {movie.duration} 分钟
      </p>
      {showSummary && (
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {movie.summary}
        </p>
      )}
    </Link>
  );
}